import styled from "styled-components";
import Image4 from "../../assets/images/health-back.jpg";

export const StyledSection = styled.div`
  padding: 4rem 4rem;
  .header-text {
    height: 300px;
  }
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 72px;
    line-height: 81px;
    color: ${({ theme }) => theme.colors.primary};
  }

  h2 {
    color: ${({ theme }) => theme.colors.textColor};
    font-style: normal;
    font-size: 38px;
    line-height: 43px;
  }
  p {
    font-style: normal;
    font-size: 20px;
    line-height: 22px;
    color: #000000;
  }
  @media (max-width: 768px) {
    padding: 4rem 0px;

    .header-text {
      height: 200px;
    }
    h1 {
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 40px;
      color: ${({ theme }) => theme.colors.primary};
    }

    h2 {
      color: ${({ theme }) => theme.colors.textColor};
      font-style: normal;
      font-size: 26px;
      line-height: 40px;
    }
  }
`;
export const StyledCover = styled.div`
  .barr {
    height: 80px;
    background-color: rgba(0, 119, 231, 0.151);
    margin-top: 6rem;
    display: flex;
    align-items: center;
    & h1 {
      font-style: italic;
      font-weight: bold;
      font-size: 42px;
      line-height: 60px;
      text-align: center;
      color: #0042a6;
      margin: auto;
    }
  }
  .cover-image {
    background-image: url(${Image4});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 550px;
    position: relative;

    ul {
      position: absolute;
      top: 30px;
      right: 0;

      & li {
        font-style: normal;
        font-weight: bold;
        font-size: 28px;
        line-height: 40px;
        color: #0042a6;
      }
    }
  }
  @media (max-width: 768px) {
    .cover-image {
      background-size: cover;
    }
    .barr {
      & h1 {
        font-size: 26px;
        line-height: 40px;
      }
    }
    .cover-image {
      & ul {
        & li {
          font-style: normal;
          font-weight: bold;
          font-size: 24px;
          line-height: 30px;
          color: #0042a6;
        }
      }
    }
  }
`;
